(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgb-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mgb-slideshow')) {
    customElements.define('mgb-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = Number(this.dataset.speed || 5) * 1000;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const slideIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (slideIndex >= 0) this.show(slideIndex, false);
        });
        this.show(this.index, false);
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(nextIndex, restart) {
        if (this.slides.length < 2) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        const previousIndex = (this.index - 1 + this.slides.length) % this.slides.length;
        const nextSlideIndex = (this.index + 1) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-previous', index === previousIndex);
          slide.classList.toggle('is-next', index === nextSlideIndex);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (restart) { this.stop(); this.start(); }
      }
      start() {
        if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1, false), this.speed);
      }
      stop() { window.clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgb-tv"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mgb-tv-carousel')) {
    customElements.define('mgb-tv-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.mgb-tv-grid');
        const navigation = this.querySelector('.mgb-tv-navigation');
        const cards = [...track.children];
        this.lastInteraction = 0;
        this.userPaused = false;
        this.hovered = false;
        const move = direction => {
          const max = track.scrollWidth - track.clientWidth;
          const step = (cards[0]?.getBoundingClientRect().width || track.clientWidth) + 14;
          let left = track.scrollLeft + direction * step;
          if (direction > 0 && track.scrollLeft >= max - 2) left = 0;
          if (direction < 0 && track.scrollLeft <= 2) left = max;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.querySelector('[data-tv-prev]').addEventListener('click', () => move(-1), { signal });
        this.querySelector('[data-tv-next]').addEventListener('click', () => move(1), { signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.mgb-tv-card');
          if (card) track.scrollLeft += card.getBoundingClientRect().left - track.getBoundingClientRect().left;
        }, { signal });
        this.addEventListener('play', event => {
          if (event.target.tagName === 'VIDEO') {
            this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
          }
        }, { signal, capture: true });
        this.resize = new ResizeObserver(() => { navigation.hidden = track.scrollWidth <= track.clientWidth + 2; });
        this.resize.observe(track);
        const pauseButton = this.querySelector('[data-tv-pause]');
        const enabled = this.dataset.autoplay !== 'false';
        pauseButton.hidden = !enabled;
        pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          pauseButton.textContent = this.userPaused ? '▶' : 'Ⅱ';
          pauseButton.setAttribute('aria-pressed', String(this.userPaused));
          pauseButton.setAttribute('aria-label', this.userPaused ? 'Resume automatic scrolling' : 'Pause automatic scrolling');
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.hovered = true;
        }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; }, { signal });
        ['pointerdown', 'pointerup', 'keydown', 'wheel'].forEach(type => {
          this.addEventListener(type, () => { this.lastInteraction = Date.now(); }, { signal, passive: true });
        });
        this.addEventListener('shopify:block:select', () => { this.editorSelected = true; }, { signal });
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; }, { signal });
        const interval = Math.max(3, Number(this.dataset.interval) || 4) * 1000;
        if (enabled) this.timer = window.setInterval(() => {
          const rect = track.getBoundingClientRect();
          if (document.hidden || this.userPaused || this.hovered || this.editorSelected ||
              this.matches(':focus-within') || Date.now() - this.lastInteraction < interval ||
              matchMedia('(prefers-reduced-motion: reduce)').matches ||
              rect.bottom <= 0 || rect.top >= window.innerHeight ||
              track.scrollWidth <= track.clientWidth + 2 ||
              [...this.querySelectorAll('video')].some(video => !video.paused && !video.ended)) return;
          move(1);
        }, interval);
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.abort?.abort();
        this.resize?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
